/*
 * The main quiz component, load the questions from quiz.json
 * and display them along with answers. Once the quiz is completed
 * The QuizComplete component will render and receives the answers
 * along with recommendations for the user based on their decisions
 */

import React from "react";
import QuizQuestion from "../../components/QuizQuestion";
import QuizAnswers from "../../components/QuizAnswers";
import QuizComplete from "../../components/QuizComplete";
import quiz from "./quiz";
import quizImageMap from "./quizImages";
import "./styles.scss";

// The main questions and their order (followup questions will be chosen automatically)
const questionPath = [
  "wash",
  "commute",
  "coffee-catchup",
  "lunch",
  "grocery-shopping",
  "grocery-shopping-bags",
  "clothes",
  "compost",
  "chores",
  "cleaning",
  "recreation"
];

function StoryQuizPage(props) {
  const [questionIndex, setQuestionIndex] = React.useState(0);
  const [question, setQuestion] = React.useState(
    quiz[questionPath[questionIndex]]
  );
  const [isComplete, setIsComplete] = React.useState(false);

  // Store the answers to each question
  const [answerMap, setAnswerMap] = React.useState({});

  // Store recommendations for showing at the end
  const [recommendations, setRecommendations] = React.useState([]);

  const completeQuiz = () => {
    setIsComplete(true);
  };

  // Progress to the next question in the questionPath
  const nextQuestion = () => {
    if (questionIndex < questionPath.length - 1) {
      const nextQuestionIndex = questionIndex + 1;
      setQuestionIndex(nextQuestionIndex);
      setQuestion(quiz[questionPath[nextQuestionIndex]]);
    } else {
      completeQuiz();
    }
  };

  const answerQuestion = answerId => {
    setAnswerMap({
      ...answerMap,
      [question.id]: answerId
    });

    const answer = question.answers.find(x => x.id === answerId);

    // When the user chooses a more wasteful answer, store the associated recommendation
    if (answer.recommendation) {
      setRecommendations([...recommendations, answer.recommendation]);
    }

    if (answer.followup) {
      // Show the followup depending on the answer
      setQuestion(quiz[answer.followup]);
    } else {
      nextQuestion();
    }
  };

  if (isComplete) {
    return (
      <QuizComplete answerMap={answerMap} recommendations={recommendations} />
    );
  }

  return (
    <React.Fragment>
      <QuizQuestion title={question.text} image={quizImageMap[question.id]} />
      <QuizAnswers
        answers={question.answers}
        onAnswer={answerQuestion}
        questionId={question.id}
      />
    </React.Fragment>
  );
}

export default StoryQuizPage;
